<template>
  <div id="quickquote-vacation-home-step-1-component">
    <h-1-and-tooltip
      :h1="contentModel.SharedFields.LabelHeadingStep1"
      :tooltip="contentModel.SharedFields.TooltipHeadingStep1"
    />
    <section>
      <article class="flow-group">
        <div class="control">
          <h-3-and-tooltip
            data-test="quickquote-vacation-home-headline-address"
            :h3="contentModel.LabelFindHouse"
            :tooltip="contentModel.TooltipFindHouse"
          />
          <Field
            name="quickquote-validation-address"
            :model-value="vueModelData.TemplateModel.SelectedAddressTemplate"
            :rules="'required'"
            label="Adresse"
          >
            <address-search
              v-model="vueModelData.TemplateModel.SelectedAddressTemplate"
              class="v-select-search-icon"
              :init-value="vueModelData.TemplateModel.SelectedAddressTemplate"
              data-test="quickquote-vacation-home-select-address"
              name="quickquote-validation-address"
              :placeholder="contentModel.PlaceholderAddressTypeaheadBox"
              @click.native="activityInAddressField"
            />
          </Field>
          <ValidationError name="quickquote-validation-address" />

          <div v-if="houseFound" data-test="quickquote-vacation-home-bbr-details">
            <div class="row padding-bottom padding-top">
              <div class="small-12 medium-6 columns" v-html="contentModel.LabelHomeSize" />
              <div
                class="small-12 medium-6 columns"
                v-html="
                  quickQuoteStepModelData.houseDetails.HouseSize +
                  ' ' +
                  contentModel.LabelSquareMeter
                "
              />
            </div>
            <div class="row padding-bottom padding-top">
              <div class="small-12 medium-6 columns" v-html="contentModel.LabelOuthouseSize" />
              <div class="small-12 medium-6 columns">
                <span
                  v-html="
                    quickQuoteStepModelData.houseDetails.OuthouseSize +
                    ' ' +
                    contentModel.LabelSquareMeter
                  "
                />
              </div>
            </div>
            <div class="row padding-bottom padding-top">
              <div class="small-12 medium-6 columns" v-html="contentModel.LabelBasementSize" />
              <div class="small-12 medium-6 columns">
                <span
                  v-html="
                    quickQuoteStepModelData.houseDetails.BasementSize +
                    ' ' +
                    contentModel.LabelSquareMeter
                  "
                />
              </div>
            </div>
            <div class="row padding-bottom padding-top">
              <div
                class="small-12 medium-6 columns"
                v-html="contentModel.LabelHomeConstructionYear"
              />
              <div class="small-12 medium-6 columns">
                <span v-html="quickQuoteStepModelData.houseDetails.ConstructionYear" />
              </div>
            </div>

            <div class="row padding-bottom padding-top">
              <div class="small-12 medium-6 columns" v-html="contentModel.LabelRoofType" />
              <div class="small-12 medium-6 columns">
                <span v-html="quickQuoteStepModelData.houseDetails.RoofType" />
              </div>
            </div>

            <div
              class="info-box is-open info-box-align-left"
              v-html="contentModel.TextFindHouseBox"
            />
          </div>
        </div>

        <div v-if="houseFound" class="control">
          <h-3-and-tooltip
            data-test="quickquote-vacation-home-headline-property-type"
            :h3="contentModel.LabelPropertyType"
            :tooltip="contentModel.TooltipPropertyType"
          />

          <div
            v-for="(radio, index) in contentModel.TreelistPropertyTypes.DropdownElements"
            :key="index"
            class="radio-inline"
          >
            <Field
              :id="'PropertyType' + index"
              v-model="vueModelData.TemplateModel.VacationHomePropertyTypeId"
              :rules="'required'"
              type="radio"
              name="PropertyType"
              :value="parseInt(radio.Value)"
              label="FieldNamePropertyType"
              :data-test="'quickquote-vacation-home-input-property-type-' + radio.Value"
            />
            <label :for="'PropertyType' + index" v-html="radio.Name" />
          </div>
          <div class="radio-inline">
            <Field
              id="PropertyNull"
              v-model="vueModelData.TemplateModel.VacationHomePropertyTypeId"
              :rules="'required'"
              type="radio"
              name="PropertyType"
              :value="-1"
              :label="contentModel.FieldNamePropertyType"
              data-test="quickquote-vacation-home-input-property-other"
            />
            <label for="PropertyNull" v-html="contentModel.LabelOtherHouseType" />
          </div>
          <ValidationError
            name="PropertyType"
            data-test="quickquote-vacation-home-validation-property-type"
          />
        </div>

        <div
          v-if="houseFound && vueModelData.TemplateModel.VacationHomePropertyTypeId == 1000001"
          class="control"
        >
          <h-3-and-tooltip
            data-test="quickquote-vacation-home-headline-additional-property-type"
            :h3="contentModel.LabelVacationHomeAdditionalPropertyType"
            :tooltip="contentModel.TooltipVacationHomeAdditionalPropertyType"
          />
          <div
            v-for="(radio, index) in contentModel.TreelistVacationHomeAdditionalPropertyTypes
              .DropdownElements"
            :key="index"
            class="radio-inline"
          >
            <Field
              :id="'VacationHomeAdditionalProperty' + index"
              v-model="vueModelData.TemplateModel.VacationHomeAdditionalPropertyTypeId"
              :rules="'required'"
              type="radio"
              name="VacationHomeAdditionalProperty"
              :value="parseInt(radio.Value)"
              :label="contentModel.VacationHomeAdditionalProperty"
              :data-test="'quickquote-vacation-home-input-additional-property-type-' + radio.Value"
            />
            <label :for="'VacationHomeAdditionalProperty' + index" v-html="radio.Name" />
          </div>
          <ValidationError
            name="VacationHomeAdditionalProperty"
            data-test="quickquote-vacation-home-validation-additional-property-type"
          />
        </div>

        <div v-if="houseFound" class="control">
          <h-3-and-tooltip
            data-test="quickquote-vacation-home-headline-house-type"
            :h3="contentModel.LabelHouseType"
            :tooltip="contentModel.TooltipHouseType"
          />
          <div class="radio-inline">
            <Field
              id="'VacationHomeHouseTypeNull'"
              v-model="vueModelData.TemplateModel.VacationHomeHouseTypeId"
              :rules="'required'"
              type="radio"
              name="HouseType"
              :value="-1"
              :label="contentModel.FieldNameHouseType"
              data-test="quickquote-vacation-home-input-house-type-other"
            />
            <label for="'VacationHomeHouseTypeNull'" v-html="contentModel.LabelOtherHouseType" />
          </div>
          <div
            v-for="(radio, index) in contentModel.TreelistHouseTypes.DropdownElements"
            :key="index"
            class="radio-inline"
          >
            <Field
              :id="'VacationHomeHouseType' + index"
              v-model="vueModelData.TemplateModel.VacationHomeHouseTypeId"
              :rules="'required'"
              type="radio"
              name="HouseType"
              :value="parseInt(radio.Value)"
              label="HouseType"
              :data-test="'quickquote-vacation-home-input-house-type-' + radio.Value"
            />
            <label :for="'VacationHomeHouseType' + index" v-html="radio.Name" />
          </div>
          <ValidationError
            name="HouseType"
            data-test="quickquote-vacation-home-validation-house-type"
          />
        </div>

        <div v-if="houseFound" class="control">
          <h-3-and-tooltip
            data-test="quickquote-vacation-home-headline-commercial"
            :h3="contentModel.LabelCommercialProperty"
            :tooltip="contentModel.TooltipCommercialProperty"
          />
          <div class="row">
            <div
              v-for="(radio, index) in yesNoRadioArray(
                contentModel.SharedContent.LabelYes,
                contentModel.SharedContent.LabelNo
              )"
              :key="index"
              class="small-6 columns"
            >
              <div
                class="radio-stacked"
                :data-test="'quickquote-vacation-home-input-commercial-' + radio.Value"
              >
                <Field
                  :id="'CommercialProperty' + radio.label"
                  v-model="quickQuoteStepModelData.commercialProperty"
                  :rules="'required_notnull'"
                  type="radio"
                  name="CommercialProperty"
                  :value="radio.value"
                  label="CommercialProperty"
                />
                <label :for="'CommercialProperty' + radio.label" v-html="radio.label" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError
                name="CommercialProperty"
                data-test="quickquote-vacation-home-validation-commercial"
              />
            </div>
          </div>
        </div>

        <div v-if="houseFound" class="control">
          <hr />
          <h-3-and-tooltip
            :h3="contentModel.LabelInstallationsOnTheProperty"
            :tooltip="contentModel.TooltipInstallationsOnTheProperty"
            data-test="quickquote-vacation-home-headline-installations"
          />

          <div v-if="vueModelData.TemplateModel.Asset.RoofType.Id != 1000001" class="row">
            <div class="small-12 medium-8 columns align-self-middle">
              <LabelAndTooltip
                :label="contentModel.LabelApprovedFireRetardantMeasures"
                :tooltip="contentModel.TooltipApprovedFireRetardantMeasures"
              />
            </div>
            <div class="small-12 medium-4 columns">
              <div class="switch float-right">
                <Field
                  id="choice_no0"
                  v-model="vueModelData.TemplateModel.IsApprovedFireRetardantMeasures"
                  :rules="'required'"
                  type="radio"
                  class="switch-input"
                  name="ApprovedFireRetardantMeasures"
                  :value="false"
                />
                <label
                  for="choice_no0"
                  class="switch-label switch-label-left unselectable"
                  data-test="quickquote-vacation-home-input-approved-fire-retardant-measures-no"
                  v-html="contentModel.SharedContent.LabelNo"
                />
                <Field
                  id="choice_yes0"
                  v-model="vueModelData.TemplateModel.IsApprovedFireRetardantMeasures"
                  :rules="'required'"
                  type="radio"
                  class="switch-input"
                  name="ApprovedFireRetardantMeasures"
                  :value="true"
                />
                <label
                  for="choice_yes0"
                  class="switch-label switch-label-right unselectable"
                  data-test="quickquote-vacation-home-input-approved-fire-retardant-measures-yes"
                  v-html="contentModel.SharedContent.LabelYes"
                />
                <span class="selection-indicator" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="ApprovedFireRetardantMeasures" />
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-8 columns align-self-middle">
              <LabelAndTooltip
                :label="contentModel.LabelApprovedWaterAlarm"
                :tooltip="contentModel.TooltipApprovedWaterAlarm"
              />
            </div>
            <div class="small-12 medium-4 columns">
              <div class="switch float-right">
                <Field
                  id="choice_no1"
                  v-model="vueModelData.TemplateModel.IsApprovedWaterAlarm"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="ApprovedWaterAlarm"
                  :value="false"
                />
                <label
                  for="choice_no1"
                  class="switch-label switch-label-left unselectable"
                  data-test="quickquote-vacation-home-input-approved-water-alarm-no"
                  v-html="contentModel.SharedContent.LabelNo"
                />
                <Field
                  id="choice_yes1"
                  v-model="vueModelData.TemplateModel.IsApprovedWaterAlarm"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="ApprovedWaterAlarm"
                  :value="true"
                />
                <label
                  for="choice_yes1"
                  class="switch-label switch-label-right unselectable"
                  data-test="quickquote-vacation-home-input-approved-water-alarm-yes"
                  v-html="contentModel.SharedContent.LabelYes"
                />
                <span class="selection-indicator" />
              </div>
            </div>
            <div class="small-12 columns">
              <div
                v-if="vueModelData.TemplateModel.IsApprovedWaterAlarm"
                class="info-box is-open info-box-align-left"
                v-html="contentModel.LabelApprovedWaterAlarmAdditionalText"
              />
              <ValidationError name="ApprovedWaterAlarm" />
            </div>
          </div>

          <div class="row">
            <div
              class="small-12 medium-8 columns align-self-middle"
              v-html="contentModel.LabelBurglarAlarm"
            />
            <div class="small-12 medium-4 columns">
              <div class="switch float-right">
                <Field
                  id="choice_no2"
                  v-model="vueModelData.TemplateModel.IsApprovedBurglarAlarm"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="BurglarAlarm"
                  :value="false"
                />
                <label
                  for="choice_no2"
                  class="switch-label switch-label-left unselectable"
                  data-test="quickquote-vacation-home-input-burglar-alarm-no"
                  v-html="contentModel.SharedContent.LabelNo"
                />
                <Field
                  id="choice_yes2"
                  v-model="vueModelData.TemplateModel.IsApprovedBurglarAlarm"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="BurglarAlarm"
                  :value="true"
                />
                <label
                  for="choice_yes2"
                  class="switch-label switch-label-right unselectable"
                  data-test="quickquote-vacation-home-input-burglar-alarm-yes"
                  v-html="contentModel.SharedContent.LabelYes"
                />
                <span class="selection-indicator" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="ApprovedFloodProofingDevice" />
            </div>
          </div>
          <div class="row">
            <div
              class="small-12 medium-8 columns align-self-middle"
              v-html="contentModel.LabelIndoorSwimmingPool"
            />
            <div class="small-12 medium-4 columns">
              <div class="switch float-right">
                <Field
                  id="choice_no3"
                  v-model="vueModelData.TemplateModel.HasIndoorSwimmingPool"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="IndoorSwimmingPool"
                  :value="false"
                />
                <label
                  for="choice_no3"
                  class="switch-label switch-label-left unselectable"
                  data-test="quickquote-vacation-home-input-indoor-swimming-pool-no"
                  v-html="contentModel.SharedContent.LabelNo"
                />
                <Field
                  id="choice_yes3"
                  v-model="vueModelData.TemplateModel.HasIndoorSwimmingPool"
                  :rules="'required_notnull'"
                  type="radio"
                  class="switch-input"
                  name="IndoorSwimmingPool"
                  :value="true"
                />
                <label
                  for="choice_yes3"
                  class="switch-label switch-label-right unselectable"
                  data-test="quickquote-vacation-home-input-indoor-swimming-pool-yes"
                  v-html="contentModel.SharedContent.LabelYes"
                />
                <span class="selection-indicator" />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="IndoorSwimmingPool" />
            </div>
          </div>
        </div>
        <div v-if="houseFound" class="control">
          <hr />
          <questionnaire
            :options="policyQuestions"
            :always-show="true"
            :heading-three="true"
            @questionnaire-updated="getQuestionnaireAnswersFromId"
          />
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import { forEach } from 'lodash';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import Utility from '@/common/UtilityFunctions.js';
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import { hasProperty } from '@/common/Util/utility.js';
import H1AndTooltip from '@/components/UI/H1AndTooltip.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';

export default {
  name: 'VacationHomeQuickQuote',
  components: { AddressSearch, H1AndTooltip, H3AndTooltip },
  mixins: [QuickQuoteMixin],
  emits: ['update-personal-information', 'disable-next-button'],
  props: {
    contentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    },
    quickQuoteStepModel: {
      type: Object,
      default() {
        return {
          commercialProperty: null,
          houseDetails: {
            HouseSize: null,
            OuthouseSize: null,
            BasementSize: null,
            ConstructionYear: null,
            RoofTypeId: null,
            RoofType: null
          }
        };
      }
    }
  },
  data() {
    return {
      isBlocked: false,
      vueModelData: this.vueModel,
      quickQuoteStepModelData: this.quickQuoteStepModel
    };
  },
  computed: {
    houseFound() {
      return this.quickQuoteStepModelData.houseDetails.HouseSize !== null;
    },
    personalInformationForTagManager() {
      return {
        event: 'track-event',
        eventCategory: this.getDanishProductTypeName + ' prisberegner',
        eventAction: '01 oplysninger submit ok',
        eventLabel: 'oplysninger submit ok',
        eventValue: '0',
        eventNoninteraction: true,
        data: {
          houseYear: this.quickQuoteStepModelData.houseDetails.ConstructionYear
        }
      };
    }
  },
  watch: {
    vueModel: function (val) {
      this.vueModelData = val;
    },
    'vueModelData.TemplateModel.VacationHomePropertyTypeId': function (val) {
      if (val === -1) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      } else {
        this.updateBlockStatus();
      }
    },
    'quickQuoteStepModelData.commercialProperty': function (val) {
      this.stepModel.commercialProperty = val;
      if (val) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      } else {
        this.updateBlockStatus();
      }
    },
    'vueModelData.TemplateModel.IsApprovedFireRetardantMeasures': function (val) {
      // We should only show a warning box if the rooftype is
      if (val) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      } else {
        this.updateBlockStatus();
      }
    },
    'vueModelData.TemplateModel.SelectedAddressTemplate': function () {
      this.updateQuickQuoteAsset(
        (response) => {
          this.updateHouseDetails(response);
          this.responseSuccess(response);
          Utility.pushToTagManager({
            event: 'track-ga-vp',
            virtualPath: '/virtual/engagement/fritidshus-prisberegner-02-adressefelt-ok',
            virtualTitle: 'Virtuel - Beregn pris - fritidshus - adressefelt OK'
          });
        },
        () => {
          // this.$parent.$emit('showStdErrorModal');
          this.$parent.$parent.$parent.showQuickQuoteModalErrorValidation = false;
          this.$parent.$parent.$parent.showQuickQuoteModal = true;
          Utility.pushToTagManager({
            event: 'track-event',
            eventCategory: 'Fritidshus prisberegner',
            eventAction: '01 oplysninger søg adresse error',
            eventLabel: '',
            eventValue: '0',
            eventNoninteraction: true
          });
        }
      );
    },
    personalInformationForTagManager() {
      this.$emit('update-personal-information', this.personalInformationForTagManager);
    }
  },
  mounted() {
    this.setQuickQuoteStepModel();
  },
  methods: {
    noYesRadioArray(no, yes) {
      return [
        {
          value: false,
          label: no
        },
        {
          value: true,
          label: yes
        }
      ];
    },
    yesNoRadioArray(yes, no) {
      return this.noYesRadioArray(no, yes);
    },
    updateHouseDetails(response) {
      if (hasProperty(response, 'Asset')) {
        this.quickQuoteStepModelData.houseDetails.HouseSize = response.Asset.LivingArea;
        this.quickQuoteStepModelData.houseDetails.OuthouseSize =
          response.Asset.AdditionalBuildingsArea;
        this.quickQuoteStepModelData.houseDetails.BasementSize = response.Asset.BasementArea;
        this.quickQuoteStepModelData.houseDetails.ConstructionYear =
          response.Asset.YearOfConstruction;
        this.quickQuoteStepModelData.houseDetails.RoofTypeId = response.Asset.RoofType.Id;
        this.quickQuoteStepModelData.houseDetails.RoofType = response.Asset.RoofType.Description;

        this.stepModel.houseDetails = this.quickQuoteStepModelData.houseDetails;

        // Skip clearing the quick quote on next as it is handled in this step.
        this.vueModelData.TemplateModel.ShouldClearAsset = false;
      }
    },
    responseSuccess(response) {
      this.handleResponse(
        response,
        () => {
          // this.$parent.$emit('showQuickQuoteModalErrorValidation', true);
          this.$parent.showQuickQuoteModalErrorValidation = true;
          this.$parent.showQuickQuoteModal = true;
        },
        false
      );
    },
    setQuickQuoteStepModel() {
      const self = this;
      forEach(this.stepModel, (val, key) => {
        self.quickQuoteStepModelData[key] = val;
      });
    },
    updateBlockStatus() {
      if (
        !this.isBlocked &&
        !this.vueModelData.TemplateModel.IsApprovedFireRetardantMeasures &&
        !this.quickQuoteStepModelData.commercialProperty &&
        this.vueModelData.TemplateModel.VacationHomePropertyTypeId !== -1
      ) {
        this.$emit('disable-next-button', false);
      }
    },
    getQuestionnaireAnswersFromId(param) {
      if (param.answer.Block) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      }
      this.isBlocked = param.blockStatus;
      this.updateBlockStatus();
    },
    activityInAddressField() {
      Utility.pushToTagManager({
        event: 'track-ga-vp',
        virtualPath: '/virtual/engagement/fritidshus-prisberegner-01-adressefelt-forladt',
        virtualTitle: 'Virtuel - Beregn pris - fritidshus - adressefelt aktivitet'
      });
    }
  }
};
</script>
